<div class="add-container">
	<h1 class="add-title">Adaugă Document Cetățean</h1>
	<form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
		<div class="row align-items-center">
			<div class="col-md-6">
                <mat-form-field class="w-100 d-flex" appearance="fill">
                    <mat-label>CNP/CIF</mat-label>
                    <mat-select formControlName="cnp_cif" (selectionChange)="onCnpChange($event.value)">
                        <mat-form-field class="w-100 px-2">
                            <input matInput [formControl]="dropdownControl" />
                        </mat-form-field>
    
                        <mat-option *ngIf="showMessage" disabled>
                            <span *ngIf="!dropdownControl.value || dropdownControl.value.length < 2">Vă rugăm să introduceți 2 caractere sau mai multe</span>
                            <span *ngIf="isCnpLoading && dropdownControl.value.length >= 2">Searching...</span>
                            <span *ngIf="!isCnpLoading && loadComplete && cnps.length === 0 && dropdownControl.value && dropdownControl.value.length >= 2">No results found</span>
                        </mat-option>
    
                        <mat-option *ngFor="let value of cnps" [value]="value.cnp">
                            {{ value.name }}
                        </mat-option>
                    </mat-select>
    
                    <mat-error *ngIf="!form.controls['cnp_cif'].valid && form.controls['cnp_cif'].touched">
						Câmp obligatoriu
					</mat-error>
                </mat-form-field>
			</div>

            <div *ngIf="form.get('cnp_cif')?.value !== ''" class="col-md-6">
                <h2>CNP/CIF: {{ form.get('cnp_cif')?.value }}</h2>
            </div>
		</div>

        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">
            <div class="col">
                <mat-form-field class="w-100 d-flex" appearance="fill">
                    <mat-label>Direcție/Instituție</mat-label>
                    <mat-select #directieSelect formControlName="directie_id" (selectionChange)="onDirectieChange($event.value)">

                        <mat-form-field class="w-100 px-2">
                            <input matInput [formControl]="filterControl" placeholder="Introduceți direcția..." />
                        </mat-form-field>

                        <mat-option *ngFor="let directie of filteredDirectii | async" [value]="directie.id">
                            {{ directie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['directie_id'].valid && form.controls['directie_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Compartiment</mat-label>
                    <mat-select formControlName="compartiment_id" (selectionChange)="onCompartimenteChange($event.value)">
                        <mat-option value="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let compartiment of compartimenteActive$ | async" [value]="compartiment.id">
                            {{ compartiment.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

			<div class="col">
				<mat-form-field class="w-100" appearance="fill">
					<mat-label>Tip Document</mat-label>
					<mat-select formControlName="document_type" (selectionChange)="onTipDocumentSelected($event.value)">
                        <mat-option *ngFor="let tip of tipuriDocumente" [value]="tip.id">
                            {{ tip.name }}
                        </mat-option>
                    </mat-select>
					<mat-error *ngIf="!form.controls['document_type'].valid && form.controls['document_type'].touched">
						Câmp obligatoriu
					</mat-error>
				</mat-form-field>
			</div>

            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Notificare SMS</mat-label>
                    <mat-select formControlName="notificare_sms_allow" (selectionChange)="onSmsChange($event.value)">
                        <mat-option *ngFor="let option of notificareParameters" [value]="option.value">
                            {{ option.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <ng-container *ngIf="form.get('notificare_sms_allow')?.value === true">
                <div class="col">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Nr. de telefon</mat-label>
                        <input type="text" matInput formControlName="notificare_sms_number" />
                        <mat-error *ngIf="!form.controls['notificare_sms_number'].valid && form.controls['notificare_sms_number'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </ng-container>

            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Notificare Email</mat-label>
                    <mat-select formControlName="notificare_email_allow" (selectionChange)="onEmailChange($event.value)">
                        <mat-option *ngFor="let option of notificareParameters" [value]="option.value">
                            {{ option.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <ng-container *ngIf="form.get('notificare_email_allow')?.value === true">
                <div class="col">
                    <mat-form-field class="w-100" appearance="fill">
                        <mat-label>Adresa de email</mat-label>
                        <input type="email" matInput formControlName="notificare_email_address" />
                        <mat-error *ngIf="!form.controls['notificare_email_address'].valid && form.controls['notificare_email_address'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </ng-container>
		</div>
       
        <div class="solicitare-card__upload mb-5">
            <div class="solicitare-card__upload-header">
                <p class="upload-text">Fotografii/Documente</p>
                <button class="upload-btn" (click)="fileInput.click()" type="button">
                    <mat-icon class="upload-icon me-2">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="solicitare-card__upload-files" *ngIf="form.value.files.length > 0 && !uploading.file">
                <div class="solicitare-card__upload-file" *ngFor="let uploadedFile of form.value.files; let i = index">
                    <span class="solicitare-card__upload-file-name">
                        {{ (uploadedFile.original_name.length > 30) ? (uploadedFile.original_name | slice: 0:30) + '..' : (uploadedFile.original_name)
                        }}
                    </span>
                    <div>
                        <button class="solicitare-card__upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                            <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading.file"></mat-spinner>

            <input type="file" accept="image/png, image/jpeg, image/jpg, application/pdf" id="upload-file-input-0" #fileInput
                name="fileInput" (change)="addFile($event, 'file')" multiple style="display: none">
        </div>

		<div class="row">
			<div class="col d-flex justify-content-between">
				<button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
					{{ helper.dialogConfig.buttonLabels.close }}
				</button>
				<button class="buttons" type="submit" mat-flat-button color="primary">
					{{ helper.dialogConfig.buttonLabels.save }}
				</button>
			</div>
		</div>
	</form>
	<div class="section-spinner position-absolute" *ngIf="isLoading">
		<div class="spinner position-absolute top-50 start-50 translate-middle">
			<mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
		</div>
	</div>
</div>